import React, { useState, useEffect, useRef } from 'react';
// Importa i moduli necessari da OpenLayers
// Assicurati di averli installati: npm install ol
import 'ol/ol.css'; // Importa gli stili di base di OpenLayers
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { fromLonLat } from 'ol/proj';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import TileWMS from 'ol/source/TileWMS'; // Per caricare il WMS

import config from "../pages/config"
import WMSCapabilities from 'ol/format/WMSCapabilities';

/*
 * ====================================================================
 * Componente 1: Mappa da WMS (QGIS Server / GeoServer)
 * ====================================================================
 * Questo componente carica i layer da un servizio WMS.
 * È il metodo "professionale" se hai un server.
 */

// --- CONFIGURAZIONE WMS ---
// MODIFICA QUESTI VALORI CON QUELLI DEL TUO SERVER
const wmsUrl = config.external_services.qgis+"?service=WMS&request=GetCapabilities&map="+config.external_services.prjpath; // Esempio GeoServer
// const wmsUrl = 'http://localhost/qgis-server?service=WMS'; // Esempio QGIS Server

// Definisci qui TUTTI i layer che vuoi rendere disponibili
/*const allLayers = [
  { 
    name: 'VW_RG_VINCOLO_ART10', // Nome tecnico del layer (come in QGIS/GeoServer)
    title: 'vani', // Nome da mostrare all'utente
    visible: true // È visibile all'avvio?
  },
  { 
    name: 'Comuni', 
    title: 'Edifici',
    visible: false 
  },
  { 
    name: 'aree_verdi', 
    title: 'Aree Verdi',
    visible: true 
  }
];*/
// --- FINE CONFIGURAZIONE ---
let allLayers =[]

export function MapComponentWMS() {
  // Riferimento al <div> della mappa
  const mapElement = useRef(null); 
  // Riferimento all'oggetto mappa di OpenLayers
  const mapRef = useRef(null); 
  // Riferimento al layer WMS
  const wmsLayerRef = useRef(null); 

  // Stato React per tenere traccia dei layer visibili
  // Inizializza lo stato leggendo la configurazione 'allLayers'
  const [visibleLayers, setVisibleLayers] = useState(() => {
    return allLayers.filter(l => l.visible).map(l => l.name);
  });



  
  // 1. Inizializzazione della Mappa (viene eseguito solo una volta)
  useEffect(() => {
    // Evita errori se il div non è pronto
    if (!mapElement.current) return;

    // Sfondo OpenStreetMap
    const osmLayer = new TileLayer({
      source: new OSM(),
    });

    // Crea il layer WMS (inizialmente con i layer visibili di default)
    const wmsSource = new TileWMS({
      url: wmsUrl,
      params: { 
        'LAYERS': visibleLayers.join(','), // 'strade,aree_verdi'
        'TILED': true 
      },
      serverType: 'geoserver', // Cambia in 'qgis' se usi QGIS Server
      transition: 0,
    });

    wmsLayerRef.current = new TileLayer({
      source: wmsSource,
    });

    // Crea la mappa
    const map = new Map({
      target: mapElement.current,
      layers: [
        osmLayer, // Sfondo
        wmsLayerRef.current // Nostro layer WMS
      ],
      view: new View({
        center: fromLonLat([14.2681, 37.5079]), // Centro (Sicilia)
        zoom: 9,
      }),
    });



    const qgisServerUrl = config.apiUrl+config.api.getCapabilities;//'http://localhost/cgi-bin/qgis_mapserv.fcgi';
    const url = `${qgisServerUrl}?service=WMS&request=GetCapabilities&map=${config.external_services.prjpath}`;

    try {
    // 2. Fai la richiesta al server
    const response = fetch(url);
    const text = response.text; // Il server risponde con XML

    // 3. Usa OpenLayers per leggere l'XML
    const parser = new WMSCapabilities();
    const result = parser.read(text);

    // 4. Estrai i layer (la struttura può variare leggermente in base al tuo QGIS)
    // Di solito sono annidati dentro Capability.Layer.Layer
    const layers = result.Capability.Layer.Layer || [];

    // 5. Formatta i dati per il tuo stato React
    const formattedLayers = layers.map(layer => ({
        name: layer.Name,       // Es. "strade_comunali" (serve per le richieste WMS)
        title: layer.Title,     // Es. "Strade Principali" (da mostrare all'utente)
        visible: false          // Imposta la visibilità di default
    }));

    console.log("Layer trovati nel progetto:", formattedLayers);
    allLayers = formattedLayers;

    } catch (error) {
    console.error("Errore nel caricamento dei layer QGIS:", error);
    }




    mapRef.current = map; // Salva la mappa nel ref

    // Funzione di pulizia (quando il componente viene smontato)
    return () => {
      if (mapRef.current) {
        mapRef.current.setTarget(null);
        mapRef.current = null;
      }
    };
  }, []); // L'array vuoto [] assicura che questo Effect venga eseguito solo 1 volta

  // 2. Aggiornamento dei Layer WMS (viene eseguito quando 'visibleLayers' cambia)
  useEffect(() => {
    // Se il layer WMS non è ancora stato creato, esci
    if (!wmsLayerRef.current) return;

    // Prendi la sorgente WMS dal nostro layer
    const wmsSource = wmsLayerRef.current.getSource();
    
    // Aggiorna il parametro 'LAYERS' con la nuova lista di layer
    wmsSource.updateParams({ 
      'LAYERS': visibleLayers.join(',') 
    });
    
    console.log("Aggiornamento layer WMS:", visibleLayers.join(','));

  }, [visibleLayers]); // Questo Effect dipende dallo stato 'visibleLayers'

  // 3. Funzione per gestire il click sulla checkbox
  const handleLayerToggle = (layerName, isChecked) => {
    setVisibleLayers(prevLayers => {
      if (isChecked) {
        // Aggiungi il layer alla lista (se non c'è già)
        return [...prevLayers, layerName];
      } else {
        // Rimuovi il layer dalla lista
        return prevLayers.filter(name => name !== layerName);
      }
    });
  };

  // Stili per il pannello dei layer
  const layerSwitcherStyles = {
    position: 'absolute',
    top: '20px',
    right: '20px',
    backgroundColor: 'white',
    padding: '15px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    zIndex: 10,
    fontFamily: 'Arial, sans-serif'
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
      {/* Il <div> dove OpenLayers disegnerà la mappa */}
      <div ref={mapElement} style={{ width: '100%', height: '100%' }}></div>
      
      {/* La "finestra" (pannello) per selezionare i layer */}
      <div style={layerSwitcherStyles}>
        <h4>Seleziona Layer</h4>
        {allLayers.map(layer => (
          <div key={layer.name}>
            <input 
              type="checkbox"
              id={layer.name}
              // Controlla se il nome del layer è nell'array 'visibleLayers'
              checked={visibleLayers.includes(layer.name)}
              // Chiama l'handler quando la checkbox cambia
              onChange={(e) => handleLayerToggle(layer.name, e.target.checked)}
            />
            <label htmlFor={layer.name} style={{ marginLeft: '5px' }}>
              {layer.title}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}


/*
 * ====================================================================
 * Componente 2: Mappa da GeoJSON (File Statico)
 * ====================================================================
 * Questa è l'alternativa se non hai un server WMS.
 * Carica un file GeoJSON esportato da QGIS.
 */
export function MapComponentGeoJSON() {
  const mapElement = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!mapElement.current) return;

    // 1. Sfondo OSM
    const osmLayer = new TileLayer({
      source: new OSM(),
    });

    // 2. Layer GeoJSON
    // OpenLayers carica il file da solo
    const vectorSource = new VectorSource({
      format: new GeoJSON(),
      // IMPORTANTE: Metti il tuo file 'mappa.geojson'
      // nella cartella /public del tuo progetto React
      url: '/mappa.geojson', 
    });

    const geoJsonLayer = new VectorLayer({
      source: vectorSource,
      // Qui puoi aggiungere stili, se vuoi
    });

    // 3. Crea la Mappa
    const map = new Map({
      target: mapElement.current,
      layers: [osmLayer, geoJsonLayer], // Mette lo sfondo e poi i tuoi dati
      view: new View({
        center: fromLonLat([14.2681, 37.5079]),
        zoom: 9,
      }),
    });

    // 4. Centra la mappa sul GeoJSON quando è caricato
    vectorSource.once('change', (e) => {
      if (vectorSource.getState() === 'ready') {
        const extent = vectorSource.getExtent();
        map.getView().fit(extent, {
          padding: [50, 50, 50, 50], // Spazio dai bordi
          duration: 1000, // Animazione
        });
      }
    });

    mapRef.current = map;

    return () => {
      if (mapRef.current) {
        mapRef.current.setTarget(null);
        mapRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
      <div ref={mapElement} style={{ width: '100%', height: '100%' }}></div>
    </div>
  );
}